import React, { useState, useEffect, useRef } from 'react'
import { CSSTransition } from 'react-transition-group'
import styled from 'styled-components'
import shortid from 'shortid'
import Ping from './ping'

const PING_DELAY = 1500

const Box = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`

const Pinger = ({ pingKey, onPing }) => {
    const ref = useRef(null)
    const [lastPingKey, setLastPingKey] = useState(pingKey)
    const [pingerKey] = useState(shortid.generate())
    const [pings, setPings] = useState([])

    const removePing = (pingId) => {
        setPings(pings => pings.filter(p => p.id !== pingId))
    }

    const createPing = (local=false) => {
        const ping = {
            id: shortid.generate(),
        }
        if (local) {
            onPing()
        }
        setPings(pings => pings.concat(ping))
    }

    useEffect(() => {
        if (!ref.current) {
            return
        }
        ref.current.oncontextmenu = (e) => {
            e.preventDefault()
            createPing(true)
        }
    }, [ref.current])

    useEffect(() => {
        if (pingKey === lastPingKey || !pingKey) {
            return
        }
        if (!lastPingKey) {
            setLastPingKey(pingKey)
            return
        }
        createPing(pingKey.startsWith('local-'))
        setLastPingKey(pingKey)
    }, [pingKey])

    return (
        <Box ref={ref}>
            {pings.map((p, idx) => (
                <CSSTransition
                    key={`pinger-${pingerKey}-${p.id}`}
                    classNames='fade-grow'
                    appear
                    in
                    unmountOnExit
                    timeout={0}>
                    <Ping
                        key={`ping-${pingerKey}-${p.id}`}
                        onDestroy={() => removePing(p.id)} />
                </CSSTransition>
            ))}
        </Box>
    )

}

export default Pinger
